import { render, staticRenderFns } from "./PDPCarousel.vue?vue&type=template&id=4eda535c&scoped=true&"
import script from "./PDPCarousel.vue?vue&type=script&lang=js&"
export * from "./PDPCarousel.vue?vue&type=script&lang=js&"
import style0 from "./PDPCarousel.vue?vue&type=style&index=0&id=4eda535c&prod&lang=css&"
import style1 from "./PDPCarousel.vue?vue&type=style&index=1&id=4eda535c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eda535c",
  null
  
)

export default component.exports